import React from 'react';
import styled from 'styled-components';
import { T, useLang } from "../Translation/index";

// 样式化链接
const NameLink = styled.a`
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: #0056b3;
  }
`;

interface TableNameLinkProps {
  translationId: string;
  showIcon?: boolean;
}

const TableNameLink: React.FC<TableNameLinkProps> = ({ translationId, showIcon = true }) => {
  const lang = useLang();

  // 根据语言选择 base URL
  const baseUrl = lang === 'tw'
    ? 'https://charlycam.com/zh/vital-signs-and-health-indicators-tc'
    : 'https://charlycam.com/vital-signs-and-health-indicators-en';

  // 根据 translationId 映射 URL 片段
  let url = baseUrl;
  switch (translationId) {
    case 'wellnessLevelValue':
      url = `${url}/#wellness-score`;
      break;
    case 'pulseRateValue':
      url = `${url}/#heart-rate`;
      break;
    case 'respirationRateValue':
      url = `${url}/#breathing-rate`;
      break;
    case 'oxygenSaturationValue':
      url = `${url}/#oxygen-saturation`;
      break;
    case 'bloodPressureValue':
      url = `${url}/#blood-pressure`;
      break;
    case 'diabetesRiskValue':
      url = `${url}/#diabetes-risk`;
      break;
    case 'hypertensionRiskValue':
      url = `${url}/#hypertension-risk`;
      break;
    case 'stressLevelValue':
      url = `${url}/#stress-level`;
      break;
    case 'pnsZoneValue':
      url = `${url}/#recovery-ability`;
      break;
    case 'snsZoneValue':
      url = `${url}/#stress-response`;
      break;
    case 'hemoglobinValue':
      url = `${url}/#hemoglobin`;
      break;
    case 'hemoglobinA1CValue':
      url = `${url}/#hemoglobin-a1c`;
      break;
    case 'sdnnValue':
      url = `${url}/#hrv-sdnn`;
      break;
    case 'meanRriValue':
      url = `${url}/#mean-rri`;
      break;
    case 'rmssdValue':
      url = `${url}/#rmssd`;
      break;
    case 'prqValue':
      url = `${url}/#prq`;
      break;
    case 'sd1Value':
      url = `${url}/#sd1`;
      break;
    case 'sd2Value':
      url = `${url}/#sd2`;
      break;
    case 'lfhfValue':
      url = `${url}/#lf-hf`;
      break;
    case 'highTotalCholesterolRiskValue':
      url = `${url}/#cholesterol`;
      break;
    case 'heartAgeValue':
      url = `${url}/#heart-age`;
      break;
    case 'ascvdRiskValue':
      url = `${url}/#ascvd`;
      break;
    case 'highFastingGlucoseRiskValue':
      url = `${url}/#fasting-glucose`;
      break;
    case 'highHbA1cRiskValue':
      url = `${url}/#high-hba1c`;
      break;
    case 'lowHemoglobinRiskValue':
      url = `${url}/#low-hemoglobin`;
      break;
    case 'normalizedStressIndexValue':
      url = `${url}/#normalized-stress-index`;
      break;
    default:
      url = baseUrl; // 如果没有匹配的 translationId，使用 baseUrl
  }

  return (
    <NameLink href={url} target="_blank" rel="noopener noreferrer">
      {showIcon && 'ℹ️ '}<T id={translationId} />
    </NameLink>
  );
};

export default TableNameLink;